import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				width: '50%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '60%',
				// height: '500px'
			},
			config: {
				fields: {
					analis_name: {},
					shortname: {},
					code: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Select.vue'))
		}
	}
}